<template>
  <v-card>
    <v-data-table :headers="headers"
                  :items="categories"
                  :options.sync="options"
                  :footer-props="dataTableFooterProps"
                  :server-items-length="totalCategories"
                  :loading="categoriesLoading"
                  disable-sort
                  loading-text="Loading... Please wait">

      <template v-slot:top>
        <v-card-title class="grey--text text--darken-2">
          <v-icon class="mx-3">
            mdi-plus
          </v-icon>
          Virtual Learning Environment CMS: Categories
        </v-card-title>

        <v-card-title class="mb-10">

          <v-btn class="mr-5 ml-2"
                 rounded
                 color="primary"
                 dark
                 large
                 @click="addItem()"
          >
            <v-icon
            >
              mdi-plus
            </v-icon>
            Add a Category
          </v-btn>

          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search Categories"
              hint="Searches the description"
              persistent-hint
              filled
              rounded
              single-line
              hide-details
              placeholder="Search categories"
              class="mr-5"
              clearable
              @click="clear"
              color="primary"
          ></v-text-field>

          <RefreshTableHeader :action="refresh" />

        </v-card-title>
      </template>

      <template v-slot:item.tags="{ item }">
        <TagsDisplay :items="item.tags"/>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn x-small
               depressed
               class="pa-3 ma-1"
               @click="editItem(item)">
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>

        <v-btn
            x-small
            depressed
            @click="deleteItem(item)"
            class="pa-3 ma-1">
          <v-icon small color="primary">
            mdi-close
          </v-icon>
        </v-btn>
      </template>

      <template v-slot:[`footer.page-text`]="items">
        <RefreshTableFooter :item="items" :action="refresh"/>
      </template>

    </v-data-table>

    <CategoryAdd />
    <CategoryEdit />
    <CategoryDelete />

  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import CategoryAdd from "@/components/Categories/CategoryAdd";
import CategoryDelete from "@/components/Categories/CategoryDelete";
import CategoryEdit from "@/components/Categories/CategoryEdit";
import RefreshTableHeader from "@/components/common/RefreshTableHeader";
import RefreshTableFooter from "@/components/common/RefreshTableFooter";
import {debounce} from "@/utility";
import TagsDisplay from "@/components/common/TagsDisplay";

export default {
  name: "Categories",
  components: {TagsDisplay, RefreshTableFooter, RefreshTableHeader, CategoryAdd, CategoryEdit, CategoryDelete},
  computed: {
    ...mapState([
      'categoriesLoading', 'totalCategories',
    ]),
    ...mapGetters([
      'categories', 'categoriesLoading', 'totalCategories', 'currentCategoryItem', 'dataTableFooterProps',
    ]),
  },
  methods: {
    ...mapActions([
      'getCategories', 'getCategory',
      'setOpenDialog', 'setCategoryPaginationOptions', 'setCategoriesSearch',
      'clearCategoryApiError',
    ]),
    addItem() {
      this.reset();
      this.setOpenDialog('categoryAdd');
    },
    async editItem(item) {
      this.reset();
      this.setOpenDialog('categoryEdit');
      await this.getCategory(item);
      if (!this.currentCategoryItem) {
        this.getCategories();
      }
    },
    async deleteItem(item) {
      this.clearCategoryApiError();
      this.setOpenDialog('categoryDelete');
      await this.getCategory(item);
      if (!this.currentCategoryItem) {
        this.getCategories();
      }
    },
    reset() {
      this.clearCategoryApiError();
    },
    refresh() {
      this.getCategories();
    },
    clear() {
      this.setCategoriesSearch('');
    },
  },
  mounted () {
    this.setCategoriesSearch('');
    this.getCategories();
  },
  data() {
    return {
      search: '',
      debouncedSearch: '',
      options: {
        itemsPerPage: 10,
      },
      headers: [
        {
          text: 'Category Name',
          align: 'start',
          value: 'name',
        },
        {
          text: 'Slug',
          align: 'start',
          value: 'slug',
        },
        {
          text: 'Description',
          align: 'start',
          value: 'description',
        },
        {
          text: 'Tags',
          align: 'start',
          value: 'tags',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        this.setCategoryPaginationOptions(this.options);
        this.getCategories();
      },
      deep: true,
    },
    search: debounce(function(newVal) {
      this.debouncedSearch = newVal;
    }, 500),
    debouncedSearch: {
      handler() {
        this.setCategoriesSearch(this.search ?? '');
        this.getCategories();
      },
    },
  },
};
</script>